import { For, Match, Show, Switch, createEffect, createMemo } from "solid-js";
import type { MainProps } from "./_model";
import { ResourcesCard } from "./components";
import { solidstate } from ":setup/qstate";
import { resources } from "./apis";
import { Loader2 } from ":src/components/loaders";
import { createInput, createSelect } from ":ui/form";

export default function Resources(props: MainProps) {
  const $list = solidstate.createAsync(resources.get);
  const $applied_filter = solidstate.create({} as { search?: string; category?: string });
  const $filters = createMemo(() => {
    const result = {
      search: ["title", "category"],
      categories: [],
    };
    const list = $list.value;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const category = item.category;
      if (!result.categories.includes(category)) {
        result.categories.push(category);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterCategory = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const category = FilterCategory.control.value;
    $applied_filter.set((s) => ({ ...s, category: category }));
  });

  return (
    <section class="flex flex-col w-full min-h-full h-full px-5 py-3  <sm:(px-2 py-1) ">
      <h1 class="text-xl  font-[600] text-black z-1 <sm:(text-22px )">Resources</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterCategory.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Category..."
          options={$filters().categories}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$list.state.loading}>
          <Loader2 msg="Loading Resources Details..." />
        </Match>
        <Match when={$list.state.failed}>an error occurred while fetching {$list.error}</Match>
        <Match when={$list.state.success}>
          <div class="grid grid-cols-4 gap-x-1rem w-full h-fit gap-y-4 py-2 overflow-x-hidden !overflow-y-auto scrollbar <sm:(grid-cols-1)">
            <For each={$list.value}>
              {(item) => {
                const show = createMemo(() => {
                  const search_keywords = $filters().search;
                  const search = $applied_filter?.value?.search?.toLowerCase?.();
                  const category = $applied_filter?.value?.category;
                  if (
                    search != undefined &&
                    !search_keywords.some((prop) => item[prop]?.toLowerCase().includes(search))
                  ) {
                    return false;
                  }
                  if (category != undefined && item?.category !== category) {
                    if (category === "undefined" && item.category == undefined) {
                      return true;
                    }
                    return false;
                  }

                  return true;
                });

                return (
                  <Show when={show()}>
                    <ResourcesCard {...item} />
                  </Show>
                );
              }}
            </For>
          </div>
        </Match>
      </Switch>
    </section>
  );
}
